import * as map from "./map";
import * as list from "./list";
import * as value from "./value";

export default {
  map,
  list,
  value
};
